<template>
    <div>
        <div v-for="(date, i) in dates" v-bind:key="'date-time-'+i" style="margin-bottom: 10px;">
            <div style="position: relative;">
                <VueDatePicker format="dd-MM-yyyy HH:mm:ss" locale="it-IT" v-model="dates[i]"></VueDatePicker>
<!--                <datetime format="DD-MM-YYYY H:i:s" width="100%" v-model="dates[i]"></datetime>-->
                <div style="position: absolute; top: 3px; right: 10px; cursor: pointer;" @click="remove(i)"><i class="fa fa-times"></i></div>
            </div>
        </div>
        <button @click="addDates">Aggiungi data</button>
    </div>
</template>

<script>
    import VueDatePicker from '@vuepic/vue-datepicker';
    export default {
        name: 'form-element-multi-date-picker',
        props: {
            value:{type:Array},
            translations: {type: Object},
            aspect: {type: Object, default: function(){ return {}; }}
        },
        data(){
            return {
                dates: [],
            }
        },
        watch:{
            dates: {
                deep: true,
                handler(){
                    this.$emit('input', this.dates);
                }
            }
        },
        mounted(){
            if(this.value != null)
                this.dates = this.value
            else
                this.dates = ["a"]
        },
        methods: {
            addDates(e){
                e.preventDefault();
                this.dates.push("d");
                return false;
            },
            remove(i){
                this.dates.splice(i, 1);
            }
        },
        components: { VueDatePicker }
    }
</script>